export default __webpack_public_path__ + "static/dingham-5caba9355771538224f9e9df9d0fd8ed.jpg";